import React from "react";
import Navbar from "./Navbar";
const Seller = ({ onNext }) => {
  return (
    <div>
      <Navbar />
      <nav className="shadow-lg relative z-10 bg-slate-50 mb-1 py-3 mt-2">
        <div className="w-full lg:px-24 md:px-12 px-2 flex justify-between items-center">
          <h1 className="text-lg font-bold tracking-wide">Sell On Amazone</h1>
          <button className="bg-orange-400 hover:bg-orange-400/90 rounded-3xl font-semibold text-sm  px-4 py-2">
            Start Selling
          </button>
        </div>
      </nav>
      <section class=" bg-white text-gray-600 body-font lg:px-20">
        <div class="container mx-auto flex px-5 py-8 md:flex-row flex-col items-center">
          <div class="lg:flex-grow md:w-1/2 lg:pr-10 md:pr-8 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
            <h1 class="title-font lg:text-5xl sm:text-4xl text-3xl md:mb-12 mb-6 font-bold text-gray-900">
              Become a seller on
              <br class="hidden lg:inline-block" />
              Apna App
            </h1>
            <div>
              <button
                onClick={onNext}
                className="bg-orange-400 hover:bg-orange-400/90 text-black rounded-3xl font-semibold shadow-lg text-md  px-5 py-2"
              >
                Start Selling
              </button>
            </div>
          </div>
          <div class="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
            <img
              class="object-cover object-center rounded"
              alt="hero"
              src="/images/sellerfirst.svg"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Seller;
